import HomePage from "./HomePage";
import { renderAddIn } from "@/utilities/renderAddIn";

renderAddIn("Homepage", function Homepage() {
  return <HomePage />;
});
